import decodeString from 'helpers/decodeString';

export { decodeString };

export const buildIframeUrl = (origin, path, baseSearchParams = '') => {
  const decodedPath = decodeString(path);

  // Validate path to prevent URL injection attacks (e.g., @evil.com/path
  // which would be interpreted as userinfo@host, loading attacker-controlled content)
  if (!decodedPath.startsWith('/') || decodedPath.startsWith('//')) {
    return null;
  }

  const constructedUrl = origin + decodedPath;

  // Verify the constructed URL's origin matches expected origin
  try {
    const parsedUrl = new URL(constructedUrl);
    if (parsedUrl.origin !== origin) {
      return null;
    }

    // Merge base URL's required query params (only add if not already present in path)
    if (baseSearchParams) {
      const baseParams = new URLSearchParams(baseSearchParams);
      [...baseParams.entries()].forEach(([key, value]) => {
        if (!parsedUrl.searchParams.has(key)) {
          parsedUrl.searchParams.set(key, value);
        }
      });
    }

    return parsedUrl.toString();
  } catch {
    return null;
  }
};

export const appendIframeParam = (url) => {
  try {
    const parsed = new URL(url);
    if (parsed.searchParams.has('iframe')) {
      return url;
    }
    parsed.searchParams.append('iframe', 'true');
    return parsed.toString();
  } catch {
    return url;
  }
};
